import { render, staticRenderFns } from "./LegalShareSelector.vue?vue&type=template&id=64be18a0&scoped=true&"
import script from "./LegalShareSelector.vue?vue&type=script&lang=js&"
export * from "./LegalShareSelector.vue?vue&type=script&lang=js&"
import style0 from "./LegalShareSelector.vue?vue&type=style&index=0&id=64be18a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64be18a0",
  null
  
)

export default component.exports